"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnswerType = void 0;
var AnswerType = {
  Text: "Text",
  TextArea: "TextArea",
  Selection: "Selection",
  Date: "Date",
  Number: "Number",
  List: "List",
  // Simple set of options to click and select, not a dropdown
  Select: "Select" // Typeahead selection list
};
exports.AnswerType = AnswerType;